/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { ADD_TOAST, REMOVE_TOAST } from "constants/ActionTypes";
import { ToastMessageActions } from "types/Actions";
import { v4 as uuidv4 } from "uuid";
import { ToastVariants } from "@spectrum-web-components/toast";

export interface ToastMessage {
  id: string;
  message: string;
  variant?: ToastVariants;
  timeout?: number;
}

export default function ToastMessagesReducer(
  state: ToastMessage[],
  action: ToastMessageActions
): ToastMessage[] {
  switch (action.type) {
    case ADD_TOAST:
      const newMessage: ToastMessage = {
        id: uuidv4(),
        message: action.toastMessage,
        variant: action.variant,
        timeout: action.timeout,
      };
      return [...state, newMessage];
    case REMOVE_TOAST:
      return state.filter((toastMessage) => toastMessage.id !== action.id);
    default:
      return state;
  }
}
